export default __webpack_public_path__ + "static/media/lions.0d4b6e8c.png";